import { render, staticRenderFns } from "./LahanVerificationFcNonCarbon.vue?vue&type=template&id=5c54f1b6"
import script from "./LahanVerificationFcNonCarbon.vue?vue&type=script&lang=js"
export * from "./LahanVerificationFcNonCarbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports